import { ConfiguratorBasicEffects } from './configurator-basic.effect';
import { ConfiguratorCartEffects } from './configurator-cart.effect';

export const ConfiguratorEffects: any[] = [
  ConfiguratorBasicEffects,
  ConfiguratorCartEffects,
];
